const KEYWORD_TO_CATEGORY: Record<string, string> = {
  uber: "Transporte",
  "99": "Transporte",
  combustivel: "Transporte",
  combustível: "Transporte",
  gasolina: "Transporte",
  onibus: "Transporte",
  ônibus: "Transporte",
  metro: "Transporte",
  metrô: "Transporte",
  estacionamento: "Transporte",

  mercado: "Mercado",
  supermercado: "Mercado",
  feira: "Mercado",

  ifood: "Alimentação",
  restaurante: "Alimentação",
  lanchonete: "Alimentação",
  padaria: "Alimentação",

  aluguel: "Moradia",
  condominio: "Moradia",
  condomínio: "Moradia",
  luz: "Moradia",
  energia: "Moradia",
  agua: "Moradia",
  água: "Moradia",
  internet: "Moradia",

  farmacia: "Saúde",
  farmácia: "Saúde",
  remedio: "Saúde",
  remédio: "Saúde",
  medico: "Saúde",
  médico: "Saúde",
  consulta: "Saúde",
  plano: "Saúde",

  cinema: "Lazer",
  show: "Lazer",
  bar: "Lazer",
  viagem: "Lazer",
  passagem: "Lazer",
  hotel: "Lazer",
  hospedagem: "Lazer",

  netflix: "Assinaturas",
  spotify: "Assinaturas",
  streaming: "Assinaturas",

  curso: "Educação",
  faculdade: "Educação",
  livro: "Educação",
  escola: "Educação",

  salario: "Salário",
  salário: "Salário",
  pagamento: "Salário",

  loja: "Compras",
  shopping: "Compras",

  roupa: "Roupas",
  roupas: "Roupas",
  camisa: "Roupas",
  calça: "Roupas",
  tenis: "Roupas",
  tênis: "Roupas",
  sapato: "Roupas",

  cabelo: "Beleza",
  salao: "Beleza",
  salão: "Beleza",
  manicure: "Beleza",
  barbeiro: "Beleza",
  maquiagem: "Beleza",

  pet: "Pets",
  petshop: "Pets",
  veterinario: "Pets",
  veterinário: "Pets",
  racao: "Pets",
  ração: "Pets",

  freela: "Freelance",
  freelance: "Freelance",
};

export function suggestCategoryName(description: string): string | null {
  const normalized = description.toLowerCase();
  for (const [keyword, category] of Object.entries(KEYWORD_TO_CATEGORY)) {
    if (normalized.includes(keyword)) return category;
  }
  return null;
}
